const SERVER_ENDPOINT = 'https://api.vitay.co.uk';
import packageInfo from '../../package.json';
import { VALIDITY_SCREENING_CONFIG } from './validity.environment';

export const environment = {
  HELP_SCOUT_ID: '2dd0e0c9-b62d-45d2-8811-e3f5fa17612d',
  VERSION: packageInfo.version,
  FB_PIXEL: {
    IS_ENABLED: false,
    PIXEL_ID: '246202623555291'
  },
  ENDPOINTS: {
    SOCKET: 'wss://api.vitay.co.uk/cable',
    ASSETS: 'https://assets.vitay.co.uk',
    BACK_END: {
      V1: `${SERVER_ENDPOINT}/api/v1`,
      V2: `${SERVER_ENDPOINT}/api/v2`,
      V3: `${SERVER_ENDPOINT}/api/v3`
    },
    FRONT_END: {
      ADMIN: 'https://admin.vitay.co.uk',
      APP: 'https://app.vitay.co.uk',
      CONFIGURATION: 'https://configuration.vitay.co.uk',
      FEEDBACK: 'https://feedback.vitay.co.uk',
      IFRAME: 'https://iframe.vitay.co.uk',
      JOBS: 'https://jobs.vitay.co.uk',
      REFERENCES: 'https://references.vitay.co.uk'
    }
  },
  ENABLE_SERVICE_WORKER: true,
  ENVIRONMENT: 'production',
  IP_INFO: 'bd86ce9ca31822',
  IS_PRODUCTION: true,
  SERVER_ENDPOINT,
  VALIDITY_SCREENING: {
    PRODUCTS: VALIDITY_SCREENING_CONFIG.PROD.PRODUCTS
  },
  SENTRY: {
    DNS: 'https://01d8b62059b8462ede398afd1946e549@o4508258504212480.ingest.us.sentry.io/4508264190246912',
    TRACE_URL: ['localhost', /^https:\/\/api\.vitay\.(co\.uk|io|ca)\/api\/$/]
  }
};
